/**
 * @flow
 */

import React, { Component } from 'react'

import {
  SectionHeadingContainer,
  SectionHeadingText,
  SectionHeadingLine
} from './styledComponents'

class SectionHeading extends Component {
  render() {
    const { sectionHeadingText, color } = this.props
    return (
      <SectionHeadingContainer>
        <SectionHeadingText as="h2">{sectionHeadingText}</SectionHeadingText>
        <SectionHeadingLine color={color} />
      </SectionHeadingContainer>
    )
  }
}

export default SectionHeading



// WEBPACK FOOTER //
// ./src/components/Events/common/SectionHeading/index.js